import axios from "axios";

export const API = {
  url: process.env.REACT_APP_MAP_BASE_DEV,
};

export const CONFIG_AUTH = {
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  client_id_map: process.env.REACT_APP_CLIENT_ID_MAP,
  secret_key_map: process.env.REACT_APP_SECRET_KEY_MAP,
};

export const HEADER_AUTH = { Authorization: `Bearer ${localStorage.getItem('token')}` }

export const getUser = async (userID) => {
  try {

    const res = await axios.get(`${process.env.REACT_APP_API_ACCOUNTV2}api/v2/user/${userID}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Refereer': process.env.REACT_APP_URL
      },
    });

    if (res.status !== 200) {
      throw res
    }

    return res.data;
  } catch (error) {
    return error
  }

};